export function defineLayout() {
    const $section = $(".posts-listing.link-out");
    const $postItems = $section.find(".post-item");

    const $count = $postItems.length;


    //for 3 and 6 item
    if($count % 3 === 0) {
        $postItems.addClass("small");

    //for 3 + 1, 3 + 2
    } else if($count > 3 && $count < 6) {
        $postItems.slice(0,3).addClass("small");

    //for seven
    } else if($count === 7) {
        $postItems.not(":nth-child(4)").addClass("small");

    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/link-out-layouts.js